import { sanitizeRichTextHtml } from './sanitized-rich-text.lib';

export function SanitizedRichText({
  html,
  preserveSafeInlineStyles = false,
  preserveBlockBoundaries = false,
}: {
  html: string;
  preserveSafeInlineStyles?: boolean;
  preserveBlockBoundaries?: boolean;
}) {
  const safeHtml = sanitizeRichTextHtml(html, {
    preserveSafeInlineStyles,
    preserveBlockBoundaries,
  });
  if (safeHtml === null) {
    return <p className="whitespace-pre-wrap">{html.replace(/<[^>]+>/gu, ' ')}</p>;
  }
  return (
    <div
      className={`space-y-3 [&_a]:text-primary [&_a]:underline [&_blockquote]:border-l-4 [&_blockquote]:border-primary [&_blockquote]:pl-4 [&_li]:ml-5 [&_ol]:list-decimal [&_ul]:list-disc${preserveBlockBoundaries ? ' min-w-0 [overflow-wrap:anywhere]' : ''}`}
      data-testid="sanitized-rich-text"
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}
